import { createCollectorProxyBrowserClient } from "@qws-org/collector-browser-sdk";

export type CollectorProxyClient = ReturnType<
  typeof createCollectorProxyBrowserClient
>;

export type SiteCollectorOptions = {
  /** Публичный URL collector-proxy-service (metricsService из GTM-конфига). */
  collectorProxyUrl: string;
  /** dev|prod — выводится из hostname запроса, см. root.tsx. */
  siteEnvironment: string;
  /** Идентификатор бренда/сайта — hostname запроса, см. root.tsx. */
  siteBrand: string;
};

let shared: { key: string; client: CollectorProxyClient } | null = null;

/**
 * Один клиент collector-proxy на документ для всех событий сайта: Web Vitals
 * (WebVitalsReporter) и FTD-воронка (ftd-telemetry). Параметры те же, что
 * были у WebVitalsReporter: appId `site-<hostname>`, environment prod|dev,
 * platform web; SDK сам ставит schemaVersion и app, шлёт POST /events/send с
 * keepalive (события не теряются при редиректе и закрытии вкладки).
 *
 * Недоступный коллектор, CORS, блокировщик рекламы — не ошибка сайта: без
 * onError SDK пишет console.error на каждое событие.
 */
export const getSiteCollectorClient = ({
  collectorProxyUrl,
  siteEnvironment,
  siteBrand,
}: SiteCollectorOptions): CollectorProxyClient => {
  const key = `${collectorProxyUrl}|${siteEnvironment}|${siteBrand}`;
  if (shared?.key === key) return shared.client;
  const client = createCollectorProxyBrowserClient({
    baseUrl: collectorProxyUrl,
    appId: {
      service: `site-${siteBrand}`,
      version: "1.0.0",
      environment: siteEnvironment,
      platform: "web",
    },
    onError: () => undefined,
  });
  shared = { key, client };
  return client;
};
